<template>
    <div id="solicitacaoAparelhoSucesso">
      <div class="container-aparelho">
        <div class="img-solicitacao">
          <img src="@/assets/img/celular-adicionado.png" alt=""/>
        </div>
        <div class="label-titulo">Obrigado pela <br> sua sugestão!</div>
        <div class="label-subtitulo">Faremos o possível <br>para cadastrar seu aparelho.</div>
      </div>
    </div>
</template>

<script>
import Vue from 'vue'
import './SolicitacaoAparelhoSucesso.css'

export default Vue.extend({
  name: 'solicitacaoAparelhoSucesso'
})
</script>
